import CamposLinks from "../campos/CamposLinks.js";
import TablaLinks from "../tablas/TablaLinks.js";
import * as Campos from "../../constantes/Campos.js";
import * as FuncionesFecha from "../../funciones/FuncionesFecha.js";

const esUrlValida = (url) => {
  try {
    new URL(url);
    return true;
  } catch (err) {
    return false;
  }
}

// Funciones para CuadroEditableLista

export const armarFilasTabla = (lista, idElegido, onEditarItem, onEliminarItem) => {
  return (
    <TablaLinks
      lista={lista}
      idElegido={idElegido}
      onEditarItem={onEditarItem}
      onEliminarItem={onEliminarItem}
    />
  );
}

export const OrdenarLista = (itemA, itemB) => {
  const fechaPublicacionA = FuncionesFecha.CamposToDate(itemA.anioPublicacion, itemA.mesPublicacion, itemA.diaPublicacion);
  const fechaPublicacionB = FuncionesFecha.CamposToDate(itemB.anioPublicacion, itemB.mesPublicacion, itemB.diaPublicacion);
  return fechaPublicacionA - fechaPublicacionB;
}

// Funciones para EditarItemLista

export const CamposEdicion = (idPadre, item, editar, actualizar, onCampoChange) => {
  return (
    <CamposLinks
      idPadre={idPadre}
      item={item}
      editar={editar}
      actualizar={actualizar}
      onCampoChange={onCampoChange}
    />
  );
}

export const OnCampoChange = (item, campo, valor) => {
  switch (campo) {
    case Campos.Link.TIPO_LINK:
      return { ...item, tipoLink: valor };
    case Campos.Link.FUENTE_INFORMACION:
      return { ...item, fuenteInformacion: valor };
    case Campos.Link.FECHA_PUBLICACION:
      return {
        ...item,
        anioPublicacion: valor[FuncionesFecha.ANIO],
        mesPublicacion: valor[FuncionesFecha.MES],
        diaPublicacion: valor[FuncionesFecha.DIA],
      };
    case Campos.Link.URL:
      return { ...item, url: valor };
    case Campos.Link.VALIDO:
      return { ...item, valido: valor };
    case Campos.Link.FECHA_VALIDEZ:
      return { ...item, fechaValidacion: valor };
    case Campos.Link.OBSERVACIONES:
      return { ...item, observaciones: valor };
    default:
      throw new Error("Campo "+campo+ " no definido");
  }
};

export const ValidarItemGrabar = (item) => {
  let error = "";
  if (!item) {
    error = "No se informaron datos para el link";
  } else if (!item.tipoLink) {
    error = "Debe seleccionar el tipo de link";
  } else if (!item.url || item.url === "") {
    error = "Debe ingresar la URL";
  } else if (!esUrlValida(item.url)) {
    error = "La URL ingresada no tiene un formato válido";
  } else if (
    item.anioPublicacion &&
    (item.anioPublicacion < FuncionesFecha.ANIO_MINIMO ||
      item.anioPublicacion > FuncionesFecha.ANIO_MAXIMO)
  ) {
    error = "La fecha de publicación es inválida";
  } else {
    const fechaPublicacion = FuncionesFecha.CamposToFechaBaseInicial(
      item.anioPublicacion,
      item.mesPublicacion,
      item.diaPublicacion
    );
    if (item.anioPublicacion && !fechaPublicacion < FuncionesFecha.FechaBaseMinima()) {
      error = "La fecha de publicación es inválida";
    } else if (
      item.fechaValidacion < FuncionesFecha.FechaBaseMinima() ||
      item.fechaValidacion > FuncionesFecha.FechaBaseActual()
    ) {
      error = "La fecha de validación es inválida";
    }
  }
  return error;
}